<template>
  <el-dialog
    title="排除"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    @close="close"
    width="548px"
  >
    <el-form
      :model="excludeForm"
      :label-width="'95px'"
      :disabled="isReadOnly"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="节点名称" prop="name" style="position: relative;" >
        <div class="name-wrap">
          <el-input
            show-word-limit
            maxlength="50"
            v-model="excludeForm.name"
            style="width:80%"
            class="ex-input"
          ></el-input>
          <div class="name-wrap-setName" @click="setName">智能命名</div>
        </div>
      </el-form-item>

      <el-form-item label="源数据人群" prop="sourceNodeId">
        <div class="selectBox">
          <el-select
            v-model="excludeForm.sourceNodeId"
            placeholder="请选择"
            style="width:80%"
            :disabled="dataForm"
            class="ex-input1"
            @change="sourceNodeIdChange"
          >
            <el-option
              v-for="item in options"
              :key="item.nodeId"
              :label="item.nodeName"
              :value="item.nodeId"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="排除人群"  v-if="excludeShow">
        <!-- 升级 -->
        <div class="scrollable-div">
          <div class="selectBox" v-for="item in options1">
            <div>
              <span>{{ item.nodeName }}</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item label="排除人群" prop="excludeNodeId">
        <div class="selectBox">
          <el-select
            v-model="excludeForm.excludeNodeId"
            placeholder="请选择"
            style="width:80%"
            :disabled="dataForm"
            class="ex-input1"
          >
            <el-option
              v-for="item in options"
              :key="item.nodeId"
              :label="item.nodeName"
              :value="item.nodeId"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          class="switchover"
          @click="switchover"
          icon="el-icon-sort"
          style="width:40px"
          size="mini"
        ></el-button>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" v-loading="loading" :disabled="isReadOnly" @click="excludeSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "excludeDialog",
  data() {
    let validatesid = (rule, value, callback) => {
      if (this.excludeForm.excludeNodeId !== "") {
        this.$refs.ruleForm.validateField("excludeNodeId");
      }
      callback();
    };
    let validateeid = (rule, value, callback) => {
      if (value === this.excludeForm.sourceNodeId) {
        callback(new Error("源数据人群和排除人群不能是同一个节点!"));
      } else {
        callback();
      }
    };
    return {
      excludeShow:false,//判断显示隐藏
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        sourceNodeId: [
          { required: true, message: "请选择源数据人群", trigger: "change" },
          { validator: validatesid, trigger: "change" },
        ],
        excludeNodeId: [
          { required: true, message: "请选择排除人群", trigger: "change" },
          { validator: validateeid, trigger: "change" },
        ],
      },
      excludeForm: {
        name: "",
        sourceNodeId: "",
        excludeNodeId: "",
      },
      options: [],
      nodeName: "",
      dataForm:true
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
    getNameLength: function() {
      return this.excludeForm.name.length;
    },
  },
  components: {},
  created() {
     mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        let formData
        if (res.data && res.data.excludeNode && res.data.excludeNode.dataList && res.data.excludeNode.dataList.length > 1) {
          formData = res.data.excludeNode
          this.excludeForm.name = res.data.name
          if(formData.dataList.length!==[]){
             this.dataForm=false;
          }
          if (formData && formData.sourceNodeId) {
            this.excludeForm.sourceNodeId = formData.sourceNodeId
            const newArr = formData.dataList.filter( item => item.nodeId !== formData.sourceNodeId);
            this.options1 = newArr;
            this.excludeShow = true;
          }
          if (formData && formData.excludeNodeId) {
            this.excludeForm.excludeNodeId = formData.excludeNodeId
          }
          this.options = formData &&  formData.dataList || []
        }
      }
    })
  },
  methods: {
    //源数据人群---升级
    sourceNodeIdChange(e){
     //使用 filter() 方法删除对应 id 的对象
     sessionStorage.setItem('options',JSON.stringify(this.options))
     if(e!==''){
      let optionsParams = JSON.parse(JSON.stringify(this.options))
      const newArr = optionsParams.filter( item => item.nodeId !== e);
      this.options1 = newArr;
      this.excludeShow = true;
     }
    },
    // 智能命名
    setName(){
      mnode.getAutoName1(this.nodeId,this.excludeForm.sourceNodeId).then(res=>{
        console.log(res);
        if(res.code){
          this.excludeForm.name = res.data
        }else if (res.code == undefined && res.data.code === 0){
          this.$message.warning(res.data.message)
        }
      })
    },
    excludeSubmit() {
      if (this.loading) {
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify();
          if (data) {
            this.loading = true;
            mnode.updateDetailexclude(data).then(res => {
              this.loading = false;
              if (res.code === 1) {
                this.$message.success(res.message)
                this.viewVisible = false
                this.$emit('change-name', data)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    getDataify() {
      let formData = {};
      let data = this.excludeForm;
      formData.nodeId = this.$props.nodeId;
      formData.name = this.excludeForm.name;
      formData.sourceNodeId = this.$data.excludeForm.sourceNodeId;
      formData.excludeNodeId = this.$data.excludeForm.excludeNodeId; 
      // formData.excludeNode = JSON.parse(
      //   JSON.stringify(data, (k, v) => {
      //     return k === "name" ? undefined : v;
      //   })
      // );
      return formData;
    },
    switchover() {
      let val = this.$data.excludeForm.sourceNodeId;
      this.$data.excludeForm.sourceNodeId = this.$data.excludeForm.excludeNodeId;
      this.$data.excludeForm.excludeNodeId = val;
    },
    close() {
      this.viewVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.selectBox {
  width: 100%;
  display: flex;
  position: relative;
}
.setName{
 position: absolute;
 right:140px;
 top:0px;
 color: #a585ea;
 cursor: pointer;
 &:hover{
   color: #fe4d45;
 }
}
.ex-input ::v-deep .el-input__inner {
  padding-right: 50px !important;
}
.ex-input1 ::v-deep .el-input__inner {
  padding-right: 50px !important;
}
.scrollable-div {
   height: 120px!important;
   overflow: auto!important;
   border:1px solid #ccc;
   padding:8px;
   padding-top:4px;
   border-radius:4px;
}
.name-wrap{
  display: flex;
  align-items: center;
  &-setName{
    color: #7f85e9;
    cursor: pointer;
    margin-left: 8px;
  }
}
</style>
